import * as yup from "yup";

export function authenticationAppSchema({ isShowSMS, isShowApp }) {
  return yup
    .object({
      appCode: isShowApp
        ? yup.string().required("وارد کردن کد الزامی است.")
        : "",
      emailCode: yup.string().required("وارد کردن کد ایمیل شده الزامی است."),
      smsCode: isShowSMS
        ? yup.string().required("وارد کردن کد ارسالی الزامی است.")
        : "",
    })
    .required();
}
